<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">沟通备注</span>
      <span class="zn-text-grey">会把内容解析到人选 沟通备注和一部分人选字段里</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div style="font-size:16px;padding-bottom:10px;color:#444;">当前人选：{{ radish.姓名 }}（{{ radish.公司 }}）</div>
      <div
        v-loading="submiting"
        v-if="ready"
        element-loading-text="努力解析中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="zn-content-item">
          <div class="zn-text-grey">
            简要自我介绍
            <el-tag
              size="small"
              effect="light"
              type="danger"
              v-if="project._id"
              @click="is331Show = !is331Show"
              style="margin-left:10px;cursor:pointer;border:1px solid #f56c6c"
              >三三一法则</el-tag
            >
          </div>
          <div style="padding-left:15px">
            【对方名字 】总您好，我是专做【 你所在领域】 的猎头，关注您很久了， 近期有个非常好的职位机会想跟您沟通，是做
            【你所在领域 】这么久以来最好的一个职位机会， 第一时间想跟您沟通，还请您保密，我是受委托来做定向寻访的。
          </div>
        </div>
        <div class="zn-content-item">
          <div class="zn-text-grey">人选沟通备注</div>
          <div style="padding-left:15px">
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:50px"><i style="color:#f00">* </i>意向：</div>
              <el-select size="mini" v-model="formData.意向">
                <el-option v-for="(opt, k) in yiXiang" :key="k" :label="opt" :value="opt"></el-option>
              </el-select>
            </div>
            <div
              class="zn-content-item"
              v-if="
                !['IBD-投行', 'FI-债券开发执行', 'FIS-债券销售', 'IS-机构销售', 'DS-渠道销售'].includes(cateRenzhiCate)
              "
            >
              <div class="zn-text-grey">关键标签：</div>
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="
                  cateRenzhiCate == 'RI-研究'
                    ? '您看【xx赛道】几年了？您最大的优势是什么？'
                    : '“ 您在目前公司多长时间？总共工作多久了？您本科学校是？您内部是如何考核的呢？您的考核排名是？您觉得您最大的强项是？/您最突出的一个成就是？ ”'
                "
                v-model="formData.关键标签"
              >
              </el-input>
            </div>
            <!-- IBD -->
            <div
              class="zn-content-item-inline"
              v-if="cateRenzhiCate == 'IBD-投行' && (formData.意向 == '需要推动' || formData.意向 == '不看机会')"
            >
              <div class="zn-text-grey" style="width:100px">项目结束时间：</div>
              <el-input size="mini" placeholder="您在手的项目预计什么时候结束" v-model="formData.项目结束时间">
              </el-input>
            </div>
            <!-- IBD end -->
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:160px">本科院校：</div>
              <el-input
                size="mini"
                placeholder="您本硕学校是那两所"
                v-model="radish.本科院校"
                @change="changeRadish('本科院校', radish.本科院校)"
              >
              </el-input>
              <div class="zn-text-grey" style="width:160px;margin-left:10px">硕士院校：</div>
              <el-input
                size="mini"
                placeholder="您本硕学校是那两所"
                v-model="radish.硕士院校"
                @change="changeRadish('硕士院校', radish.硕士院校)"
              >
              </el-input>
            </div>
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:50px">地域：</div>
              <el-select
                size="mini"
                v-model="radish.地域"
                filterable
                multiple
                @change="changeRadish('地域', radish.地域)"
                style="width:100%"
              >
                <el-option v-for="(opt, k) in diYu" :key="k" :label="opt" :value="opt"></el-option>
              </el-select>
            </div>
            <!-- IBD -->
            <template v-if="cateRenzhiCate == 'IBD-投行'">
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">业绩（承揽）：</div>
                <el-select
                  size="mini"
                  v-model="radish.业绩"
                  placeholder="您在部门内部今年考核排名怎么样？"
                  @change="changeRadish('业绩', radish.业绩)"
                  style="width:100%"
                >
                  <el-option v-for="(label, val) in yeji2" :key="label" :label="label" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">职业资格：</div>
                <el-select
                  size="mini"
                  v-model="radish.职业资格"
                  placeholder="您目前是准保或保代吗？考过CPA或者司法考试吗？"
                  filterable
                  multiple
                  @change="changeRadish('职业资格', radish.职业资格)"
                  style="width:100%"
                >
                  <el-option label="保代" value="保代"></el-option>
                  <el-option label="CPA" value="CPA"></el-option>
                  <el-option label="法律从业资格" value="法律从业资格"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">语言标签：</div>
                <el-select
                  size="mini"
                  v-model="radish.语言标签"
                  placeholder="您英语水平如何"
                  filterable
                  multiple
                  @change="changeRadish('语言标签', radish.语言标签)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in yuyan" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">细分职能：</div>
                <el-select
                  size="mini"
                  v-model="radish.细分职能"
                  placeholder="您目前偏承做还是承揽？"
                  filterable
                  multiple
                  @change="changeRadish('细分职能', radish.细分职能)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in xi" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">擅长方向：</div>
                <el-select
                  size="mini"
                  v-model="radish.擅长方向"
                  placeholder="您做什么行业或区域的项目比较多？"
                  filterable
                  multiple
                  @change="changeRadish('擅长方向', radish.擅长方向)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in shan" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:80px">项目储备：</div>
                <el-input
                  size="mini"
                  placeholder="目前有几个储备项目？什么项目？预计申报时间是？预计创收情况是？"
                  v-model="formData.项目储备"
                >
                </el-input>
              </div>
            </template>
            <!-- FI -->
            <template v-else-if="cateRenzhiCate == 'FI-债券开发执行'">
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">细分职能：</div>
                <el-select
                  size="mini"
                  v-model="radish.细分职能"
                  placeholder="您是承揽还是承做"
                  filterable
                  multiple
                  @change="changeRadish('细分职能', radish.细分职能)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in xi" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">擅长方向：</div>
                <el-select
                  size="mini"
                  v-model="radish.擅长方向"
                  placeholder="您主要做哪些省份的业务"
                  filterable
                  multiple
                  @change="changeRadish('擅长方向', radish.擅长方向)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in shan" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">团队情况：</div>
                <el-input
                  size="mini"
                  placeholder="您带的团队去年的创收是？今年市场不好，您团队的创收是？"
                  v-model="formData.团队情况"
                >
                </el-input>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">渠道资源：</div>
                <el-input
                  size="mini"
                  placeholder="项目来源主要是个人承揽吗？公司营业部对接的资源大概占到多少，50%？"
                  v-model="formData.渠道资源"
                >
                </el-input>
              </div>
            </template>
            <!-- FIS -->
            <template v-else-if="cateRenzhiCate == 'FIS-债券销售'">
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">细分职能：</div>
                <el-select
                  size="mini"
                  v-model="radish.细分职能"
                  placeholder="您目前销售的产品类型主要包括？"
                  filterable
                  multiple
                  @change="changeRadish('细分职能', radish.细分职能)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in xi" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">擅长方向：</div>
                <el-select
                  size="mini"
                  v-model="radish.擅长方向"
                  placeholder="您目前对接的主要资方是？"
                  filterable
                  multiple
                  @change="changeRadish('擅长方向', radish.擅长方向)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in shan" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
            </template>
            <!-- IS -->
            <template v-else-if="cateRenzhiCate == 'IS-机构销售'">
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">细分职能：</div>
                <el-select
                  size="mini"
                  v-model="radish.细分职能"
                  placeholder="您对接哪类机构客户？"
                  filterable
                  multiple
                  @change="changeRadish('细分职能', radish.细分职能)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in xi" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">擅长方向：</div>
                <el-select
                  size="mini"
                  v-model="radish.擅长方向"
                  placeholder="您最擅长哪类产品/服务的销售？"
                  filterable
                  multiple
                  @change="changeRadish('擅长方向', radish.擅长方向)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in shan" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
            </template>
            <!-- DS -->
            <template v-else-if="cateRenzhiCate == 'DS-渠道销售'">
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">细分职能：</div>
                <el-select
                  size="mini"
                  v-model="radish.细分职能"
                  placeholder="您负责哪类渠道？"
                  filterable
                  multiple
                  @change="changeRadish('细分职能', radish.细分职能)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in xi" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
            </template>
            <!-- RI -->
            <template v-else-if="cateRenzhiCate == 'RI-研究'">
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">擅长方向：</div>
                <el-select
                  size="mini"
                  v-model="radish.擅长方向"
                  placeholder="重点覆盖哪些行业？"
                  filterable
                  multiple
                  @change="changeRadish('擅长方向', radish.擅长方向)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in shan" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
            </template>
            <!-- PEVC -->
            <template v-else-if="cateRenzhiCate == 'PEVC-股权投资'">
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">细分职能：</div>
                <el-select
                  size="mini"
                  v-model="radish.细分职能"
                  placeholder="您主要专注于哪些领域？"
                  filterable
                  multiple
                  @change="changeRadish('细分职能', radish.细分职能)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in xi" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">擅长方向：</div>
                <el-select
                  size="mini"
                  v-model="radish.擅长方向"
                  placeholder="您主要看哪些细分赛道？"
                  filterable
                  multiple
                  @change="changeRadish('擅长方向', radish.擅长方向)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in shan" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">平台性质：</div>
                <el-select
                  size="mini"
                  v-model="radish.平台性质"
                  placeholder="想去的机构类型是什么？"
                  @change="changeRadish('平台性质', radish.平台性质)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in pingtai" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
              <div class="zn-content-item-inline">
                <div class="zn-text-grey" style="width:100px">投资阶段：</div>
                <el-select
                  size="mini"
                  v-model="radish.投资阶段"
                  placeholder="您一般主投什么阶段？"
                  @change="changeRadish('投资阶段', radish.投资阶段)"
                  style="width:100%"
                >
                  <el-option v-for="(val, k) in touzi" :key="k" :label="val" :value="val"></el-option>
                </el-select>
              </div>
            </template>
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:50px">职级：</div>
              <el-select
                size="mini"
                v-model="radish.职级"
                placeholder="您目前的职位是？"
                @change="changeRadish('职级', radish.职级)"
                style="width:100%"
              >
                <el-option v-for="(label, val) in zhiji" :key="label" :label="label" :value="val"></el-option>
              </el-select>
            </div>
            <div class="zn-content-item-inline" v-if="cateRenzhiCate != 'IBD-投行'">
              <div class="zn-text-grey" style="width:50px">业绩：</div>
              <el-select
                size="mini"
                v-model="radish.业绩"
                placeholder="您在部门内部今年考核排名怎么样？"
                @change="changeRadish('业绩', radish.业绩)"
                style="width:100%"
              >
                <el-option v-for="(label, val) in yeji" :key="label" :label="label" :value="val"></el-option>
              </el-select>
            </div>
            <template v-for="(field, k) in fields">
              <div class="zn-content-item" :key="k">
                <div class="zn-text-grey">{{ field.label }}：</div>
                <el-input type="textarea" :rows="2" :placeholder="field.placeholder" v-model="formData[field.value]">
                </el-input>
              </div>
            </template>
          </div>
        </div>
        <div class="zn-content-item">
          <div class="zn-text-grey">阿尔法认知（公司）</div>
          <div style="padding-left:15px" v-if="company._id">
            <div class="zn-content-item" v-for="(field, k) in alphaRenzhiFields" :key="k">
              <div class="zn-text-grey">{{ field.label }}：</div>
              <el-input type="textarea" :rows="2" :placeholder="field.placeholder" v-model="formData[field.value]">
              </el-input>
            </div>
          </div>
          <template v-else>
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width: 120px">人选当前公司：</div>
              <el-input
                v-model="radish.公司"
                size="mini"
                @blur="searchCompany"
                @keyup.enter.native="searchCompany"
                style="width: 200px"
              ></el-input>
            </div>
            <div v-if="radish.公司" style="padding-left:15px">
              <div style="color:#f93;line-height:2;">
                系统暂无此公司，{{
                  similarCompany.length > 0 ? '以下是系统相似的公司，点击选择可以替换' : '请新建一家'
                }}
              </div>
              <div v-for="(com, k) in similarCompany" :key="k">
                <div type="text" size="mini" class="sam-com-item" @click="chooseCompany(com.简称)">
                  {{ com.公司名称 }}({{ com.简称 }}){{ com.签约 ? `(${com.签约})` : '' }}
                </div>
              </div>
              <div>
                <el-button type="text" size="mini" style="font-size:12px" @click="gotoCompany">新建一家公司</el-button>
              </div>
            </div>
          </template>
        </div>
        <div class="zn-content-item">
          <div class="zn-text-grey">职能模块认知</div>
          <div style="padding-left:15px" v-if="company._id && radish.职能模块 && radish.职能模块.length > 0">
            <div class="zn-content-item" v-for="(field, k) in cateRenzhiFields" :key="k">
              <div class="zn-text-grey">{{ field.label }}：</div>
              <el-input type="textarea" :rows="2" :placeholder="field.placeholder" v-model="formData[field.value]">
              </el-input>
            </div>
          </div>
          <div v-else style="padding-left:15px">
            <div v-if="!company._id" class="zn-text-grey">请先{{ radish.公司 ? '正确' : '' }}填写人选当前公司</div>
            <div class="zn-content-item-inline">
              <template v-if="!radish.职能模块 || radish.职能模块.length == 0">
                <div class="zn-text-grey" style="width: 125px">请填写职能模块：</div>
                <el-select size="mini" v-model="radish.职能模块" filterable multiple @change="changeCate">
                  <el-option v-for="(opt, k) in categories" :key="k" :label="opt" :value="opt"></el-option>
                </el-select>
              </template>
            </div>
          </div>
        </div>
        <div class="zn-content-item-inline">
          <div class="zn-text-grey" style="width:140px">离职周期：</div>
          <el-select size="mini" v-model="radish.离职意愿度" @change="changeRadish('离职意愿度', radish.离职意愿度)">
            <el-option label="是，一定会走" :value="95"></el-option>
            <el-option label="不一定，得看具体情况" :value="75"></el-option>
          </el-select>
        </div>
        <div class="zn-content-item-inline">
          <div class="zn-text-grey" style="width:140px">对人选的判断/匹配度：</div>
          <el-select size="mini" v-model="formData['对人选的判断/匹配度']">
            <el-option v-for="(opt, k) in pipei" :key="k" :label="opt" :value="opt"></el-option>
          </el-select>
        </div>
        <div class="zn-content-item-inline">
          <div class="zn-text-grey" style="width:140px">针对该人选下一步操作：</div>
          <el-select size="mini" v-model="formData.针对该人选下一步操作">
            <el-option v-for="(opt, k) in nextStep" :key="k" :label="opt" :value="opt"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div v-if="radish._id" class="zn-template-submit" @click="openRadish(radish._id)" style="margin-left:-110px;">
      查看人选详情
    </div>
    <div class="zn-template-submit" @click="submit" style="margin-left:10px;">完成填写</div>
    <div class="zn-template-left-small" v-show="is331Show">
      <i
        class="el-icon-close zn-template-action"
        title="关闭"
        @click="is331Show = false"
        style="position:absolute;right:7px;top:7px;z-index:5;"
      ></i>
      <div class="zn-template-head">
        <span class="zn-template-title">{{ project.客户公司 || '' }}-{{ project.项目名称 || '' }}</span>
        <span class="zn-text-grey">项目亮点、核心关键点及风险点</span>
      </div>
      <div class="zn-template-content">
        <div class="mb-10">
          <div class="mb-5"><span class="zn-text-grey"> 项目的亮点优势： </span></div>
          <div>
            <template v-for="(val, tag) in project.项目亮点及优势标签">
              <el-tag v-if="val" size="mini" :key="tag" class="mrb-5"> {{ tag }} </el-tag>
            </template>
          </div>
          <pre style="white-space: pre-wrap;padding:0 10px 0 30px">{{ project.项目亮点及优势 }}</pre>
        </div>
        <div class="mb-10">
          <div class="zn-text-grey mb-5">核心要求：</div>
          <pre style="white-space: pre-wrap;padding:0 10px 0 30px">{{ project.核心要求汇总 || '暂无' }}</pre>
        </div>
        <div class="mb-10">
          <div class="mb-5"><span class="zn-text-grey"> 职位劣势及风险点： </span></div>
          <div>
            <template v-for="(val, tag) in project.职位劣势及风险点标签">
              <el-tag v-if="val" size="mini" :key="tag" class="mrb-5"> {{ tag }} </el-tag>
            </template>
          </div>
          <pre style="white-space: pre-wrap;padding:0 10px 0 30px">{{ project.职位劣势及风险点 }}</pre>
        </div>
      </div>
    </div>
    <el-dialog
      class="radish-dia"
      top="100px"
      width="500px"
      :visible.sync="chooseCateVisiable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :showClose="false"
    >
      <div slot="title">
        提示：
        <div class="rpg-tip-red" style="font-size:12px">
          该人选{{
            radish.职能模块 && radish.职能模块.length > 1 ? '有多个' : '没有'
          }}职能模块，请选择一个职能（不同职能会有不同的沟通备注话术）
        </div>
      </div>
      <div>
        <div class="rpg-mgb-5">
          公司：<b>{{ radish.公司 }}</b> <span class="rpg-gray">（人选当前公司）</span>
        </div>
        <div v-if="radish.职能模块 && radish.职能模块.length > 1">
          <div class="rpg-mgb-5">职能模块：<span class="rpg-gray">（人选有多个职能模块，请选择其一）</span></div>
          <el-radio-group v-model="cateRenzhiCate" size="mini">
            <el-radio v-for="(cate, k) in radish.职能模块" :key="k" border :label="cate"></el-radio>
          </el-radio-group>
        </div>
        <div v-else>
          <div class="rpg-mgb-5">职能模块：<span class="rpg-gray">（人选没有职能模块，请填写一个）</span></div>
          <el-select size="mini" v-model="cateRenzhiCate" filterable>
            <el-option v-for="(opt, k) in categories" :key="k" :label="opt" :value="opt"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="confirmCate">确 定</el-button>
        <el-button size="mini" @click="confirmCate" v-if="!radish.职能模块 || radish.职能模块.length == 0"
          >暂不填写</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { diYu } from '../../../radish/src/constant/common-var.js'
import { alphaRenzhiFields, cateRenzhiFields } from './renzhi_fields'
export default {
  props: {
    componentName: String,
    item: Object,
  },
  data() {
    return {
      formData: {},
      diYu,
      yiXiang: ['积极', '非常积极', '需要推动', '不看机会'],
      hangYe: app.industries || [],
      categories: app.categories.map(category => category.名称) || [],
      zhiji: {
        '1': '公司高管',
        '2': '部门总',
        '3': '部门副总/团队长',
        '4': '部门核心骨干（有4年及以上经验；项目的负责人）',
        '5': '新人（工作不足3年）',
      },
      yeji: {
        aaa: '排在非常靠前（前1/4）（公司平台，个人业绩、资源都非常好）',
        aa: '排在非常靠前（前1/4）（特别有信心的回答）',
        a: '嗯，排在比较前面',
        b: '还可以，但因为市场情况（大段解释）',
        '': '我们没有考核标准',
        c: '回避问题或风评不好',
      },
      yeji2: {
        aaa: '1亿以上',
        aa: '3-5千万',
        a: '1-2千万',
        c: '1千万一下',
      },
      yuyan: ['英文-1-母语水平', '英文-2-工作语言', '英文-3-口语较弱', '粤语', '日语', '法语', '小语种'],
      pingtai: ['美元/双币种', '人民币', '国家队', '险资', '券商直投', '战投/CVC'],
      touzi: ['天使', 'VC', 'Growth/PE', 'Pre-IPO', '一级半定增', 'Buyout'],
      xi: [],
      shan: [],
      pipei: ['非常匹配', '匹配', '一般匹配'],
      nextStep: ['不适合放弃', '推荐', '重点推荐', '待定'],
      fields: [
        {
          label: '诉求',
          value: '诉求',
          placeholder: '“ 您现在主要看机会的原因是？新的机会您希望和现在有什么不同？ ”',
        },
        {
          label: '期望薪酬奖金',
          value: '期望薪酬奖金',
          placeholder:
            '“ 如果考虑新机会，您的薪酬期望是？您期望月固定部分多少？全年达到一个多少的区间？（如果好聊，接着问，您目前呢？固定部分多少？全年多少？） ”',
        },
        {
          label: '理想公司',
          value: '理想公司',
          placeholder: '“ 您更偏好什么类型的公司？ ”',
        },
        {
          label: '目前薪酬职级',
          value: '目前薪酬职级',
          placeholder: '',
        },
        {
          label: '离职周期',
          value: '离职周期',
          placeholder: '“ 如果外部机会谈得特别好，您离职会比较快吗？还是要等今年奖金发完？您最理想的时间节点是？ ”',
        },
        {
          label: '最看重的点',
          value: '最看重的点',
          placeholder: '“ 抛开这个机会不说，您最理想的机会是什么样的？（大平台/高固薪/高激励/高职级的排序） ”',
        },
        {
          label: '其他在接触的机会',
          value: '其他在接触的机会',
          placeholder: '“ 您还有别的机会在接触吗？分别是哪些公司哪些岗位？进展到什么阶段了？ ”',
        },
        {
          label: '行业认知',
          value: '行业认知',
          placeholder:
            '“ 您觉得您负责的领域，哪几家公司做得比较好？您觉得做得好的关键点是哪几项？您怎么看接下来的市场？ ”',
        },
      ],
      alphaRenzhiFields,
      cateRenzhiFields,
      submiting: false,
      radish: {},
      company: {},
      project: {},
      gouFields: [
        '意向',
        '关键标签',
        '诉求',
        '期望薪酬奖金',
        '理想公司',
        '目前薪酬职级',
        '离职周期',
        '最看重的点',
        '其他在接触的机会',
        '行业认知',
        '对人选的判断/匹配度',
        '针对该人选下一步操作',
        '项目结束时间',
        '项目储备',
        '团队情况',
        '渠道资源',
      ],
      alphaRenzhi: {
        公司备注: '',
        阿尔法认知: [],
      },
      cateRenzhis: [],
      cateRenzhiCate: '',
      chooseCateVisiable: false,
      similarCompany: [],
      changedRadish: {},
      is331Show: false,
      ready: false,
    }
  },
  watch: {
    formData: {
      // 缓存到local
      handler: function(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          localStorage.setItem(this.componentName + (this.$route.params.id || ''), JSON.stringify(newVal))
        }
      },
      deep: true,
    },
    $route: {
      handler: function(val, oldVal) {
        if (val.params.id) {
          this.formData = {}
          this.initOther()
        } else {
          this.formData = {}
          this.$emit('closeTpl')
        }
      },
    },
    cateRenzhiCate: {
      handler: async function(val, oldVal) {
        if (val) {
          if (!app.categories) {
            await app.getCats()
          }
          const currentCat = app.categories.find(cat => val === cat['名称'])
          this.xi = currentCat['二级职能']
          this.shan = currentCat['擅长方向']
        }
      },
    },
  },
  methods: {
    changeRadish(field, val) {
      this.changedRadish[field] = val
    },
    async loadRadish() {
      const rid = this.item.rid || this.$route.params.id
      const res = await app.service('radish').simpleFetch({
        _id: rid,
        fields: { 沟通日志: 0, 旧系统沟通备注: 0, radishContent: 0, cvContent: 0, 任职经历: 0, 离职意愿度: 0 },
      })
      if (res.status == 'success' && res.data) {
        this.radish = res.data
        if (this.radish.公司) this.searchCompany()
        if (
          (this.radish.职能模块 && this.radish.职能模块.length > 1) ||
          !this.radish.职能模块 ||
          this.radish.职能模块.length == 0
        ) {
          this.showChooseCate()
          return false
        }
      }
      return true
    },
    async submit() {
      // return console.log(this.changedRadish)
      if (this.submiting) return this.$message('正在保存中，请稍候')
      if (!this.formData.意向) return this.$message('请填写意向')
      // if (Object.values(this.formData).every(dt=>(!dt || dt.length == 0))) return this.$message('您没有填写任何内容')
      if (!this.radish._id) return this.$message('没有人选数据')
      this.chooseCateVisiable = false
      this.ready = false
      this.submiting = true
      if (this.radish._id) {
        if (this.company._id) {
          // 保存职能模块认知
          if (this.cateRenzhiCate) {
            this.saveCateRenzhiWord()
          }
          // 保存阿尔法认知
          this.saveAlphaRenzhiWord()
        }
        // 保存到沟通备注
        let text = ''
        this.gouFields.forEach(item => {
          if (this.formData[item] && this.formData[item].length > 0) {
            text += `${item}：${this.formData[item]}\n`
          }
        })
        if (text) {
          const answer = {
            remark: [
              {
                stem: '沟通记录',
                answer: text,
                time: Date.now(),
                user: app.user.提供者 || app.user.account,
              },
            ],
            radishId: this.radish._id,
          }
          const res = await app.service('communication').upsert(answer)
          if (res == 'success') {
            app.service('radish').addKpi({
              type: '电话',
              content: { rid: this.radish._id },
            })
          }
        }

        // 保存人选数据
        if (this.formData.意向) {
          switch (this.formData.意向) {
            case '积极':
            case '非常积极':
              this.changedRadish.长期意向 = 'Y'
              break
            case '需要推动':
              this.changedRadish.长期意向 = 'F'
              break
            case '不看机会':
              this.changedRadish.长期意向 = 'N'
              break
            default:
              break
          }
        }
        if (Object.keys(this.changedRadish).length > 0) {
          await app.service('radish').modifyById({ _id: this.radish._id, data: this.changedRadish })
        }

        // 更新底层页面数据
        app.root.$refs.main.init && app.root.$refs.main.init()

        this.formData = {}
        localStorage.removeItem(this.componentName + (this.$route.params.id || ''))
        this.submiting = false
        this.ready = true
        this.$emit('closeTpl', { msg: '小阿已为您保存完毕' })
      }
    },
    async loadProject() {
      const pid = (this.$route.query && this.$route.query.p) || ''
      if (!pid) return false
      // 获取项目
      const project = await app.service('project').fetch(pid)
      if (!project) return false
      this.project = project
    },
    async loadCompany() {
      if (this.radish.公司) {
        const res = await app.service('company').getCompanySimpleList({
          query: { $or: [{ 公司名称: this.radish.公司 }, { 简称: this.radish.公司 }] },
          fields: { 简称: 1, 公司备注: 1, 阿尔法认知: 1 },
        })
        if (res.status == 'success') {
          if (res.data && res.data.length > 0) {
            this.company = res.data[0]
            this.alphaRenzhi = {
              公司备注: res.data[0].公司备注 || '',
              阿尔法认知: res.data[0].阿尔法认知 || [],
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    async loadComCateCognition() {
      if (this.company._id && this.radish.职能模块 && this.radish.职能模块.length > 0) {
        const res = await app.service('company').getComCateCognition(this.company._id)
        if (res.status === 'success') {
          const cateRenzhis = []
          this.radish.职能模块.forEach(zhi => {
            const item = res.data.find(dt => dt.职能模块 == zhi)
            if (item) {
              cateRenzhis.push(item)
            } else {
              cateRenzhis.push({ 公司: this.radish.公司, 职能模块: zhi })
            }
          })
          this.cateRenzhis = cateRenzhis
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    async saveAlphaRenzhiWord() {
      let alphaRenzhiWord = ''
      this.alphaRenzhiFields.forEach(item => {
        if (this.formData[item.value]) {
          alphaRenzhiWord += `${item.label}：${this.formData[item.value]}\n`
        }
      })
      if (!alphaRenzhiWord) return
      const log = {
        createdAt: Date.now(),
        account: app.user.account,
        content: alphaRenzhiWord,
      }
      const res = await app.service('company').alphaCognitiveAddLog({
        cid: this.company._id,
        log: log,
      })
      if (res.status === 'success') {
        this.alphaRenzhi.阿尔法认知 = res.data
        alphaRenzhiWord = ''
      } else {
        this.$message(res.msg)
      }
    },
    async saveCateRenzhiWord() {
      let cateRenzhiWord = ''
      this.cateRenzhiFields.forEach(item => {
        if (this.formData[item.value]) {
          cateRenzhiWord += `${item.label}：${this.formData[item.value]}\n`
        }
      })
      if (!cateRenzhiWord) return
      if (!this.cateRenzhiCate) return this.$message('请选择职能模块')
      const toinsert = []
      const cateRenzhi = this.cateRenzhis.find(c => c.职能模块 == this.cateRenzhiCate)
      if (!cateRenzhi.logs) cateRenzhi.logs = []
      const saveLog = { createdAt: Date.now(), account: app.user.account, content: cateRenzhiWord }
      if (cateRenzhi._id) {
        const res = await app.service('company').comCateCognitionAddLog({
          id: cateRenzhi._id,
          log: saveLog,
        })
        if (res.status === 'success') {
          cateRenzhiWord = ''
          this.cateRenzhiCate = ''
          localStorage[`cateRenzhiWord${this.company._id}`] = ''
          this.chooseCateVisiable = false
          this.loadComCateCognition()
        }
      } else {
        cateRenzhi.logs.unshift(saveLog)
        toinsert.push(cateRenzhi)
        const option = { toinsert }
        const res = await app.service('company').modifyComCateCognition({
          cid: this.company._id,
          option: option,
        })
        if (res.status === 200 || res.status === 'success') {
          cateRenzhiWord = ''
          this.cateRenzhiCate = ''
          this.$set(cateRenzhi, 'logs', res.data)
          localStorage[`cateRenzhiWord${this.company._id}`] = ''
          this.chooseCateVisiable = false
          this.loadComCateCognition()
        } else {
          this.$message(res.msg)
        }
      }
    },
    showChooseCate() {
      this.ready = false
      if (
        (this.radish.职能模块 && this.radish.职能模块.length > 1) ||
        !this.radish.职能模块 ||
        this.radish.职能模块.length == 0
      ) {
        this.chooseCateVisiable = true
      } else if (this.radish.职能模块 && this.radish.职能模块.length == 1) {
        this.cateRenzhiCate = this.radish.职能模块[0]
        this.ready = true
      }
    },
    confirmCate() {
      if (this.radish.职能模块 && this.radish.职能模块.length > 1 && !this.cateRenzhiCate)
        return this.$message('请选择职能模块')
      if ((!this.radish.职能模块 || this.radish.职能模块.length == 0) && this.cateRenzhiCate) {
        this.radish.职能模块 = [this.cateRenzhiCate]
        this.changeCate()
      }
      this.chooseCateVisiable = false
      this.ready = true
    },
    async searchCompany() {
      const hasCom = await app.service('company').checkHasCompany(this.radish.公司)
      if (hasCom.status == 'success' && hasCom.companyName) {
        this.radish.公司 = hasCom.companyName
        this.changeCompany()
      } else {
        const simiCom = await app.service('company').serchCompany(this.radish.公司)
        if (simiCom.status == 200) {
          this.similarCompany = simiCom.data
        }
      }
    },
    chooseCompany(name) {
      this.radish.公司 = name
      this.changeCompany()
    },
    async changeCompany() {
      await this.loadCompany()
      await this.loadComCateCognition()
      if (this.radish.公司) {
        await app.service('radish').modifyById({ _id: this.radish._id, data: { 公司: this.radish.公司 } })
      }
    },
    async changeCate() {
      await this.loadComCateCognition()
      if (this.radish.职能模块) {
        await app.service('radish').modifyById({ _id: this.radish._id, data: { 职能模块: this.radish.职能模块 } })
      }
    },
    async gotoCompany() {
      window.open(`${window.origin}/#/NewAddCompany?companyName=${this.radish.公司}`, '_blank')
    },
    async initData(defaultForm) {
      this.formData = defaultForm || { 期望地域: [], 期望行业: [] }
      await this.initOther()
    },
    async initOther() {
      this.ready = false
      const res = await this.loadRadish()
      await this.loadCompany()
      await this.loadProject()
      await this.loadComCateCognition()
      if (res) this.ready = true
      // console.log('init', this.radish, this.company)
    },
    openRadish(rid) {
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`)
    },
  },
}
</script>
<style>
.zn-template-left-small {
  position: fixed;
  top: 60px;
  bottom: 30%;
  left: 10%;
  width: 30%;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
</style>
